import React from "react";
const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Обо мне</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Ключевая информация
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              <span className="fw-700 border-bottom border-3 border-primary">
                Александра Шошина
              </span>
            </h2>
            <p className="text-5">
              аккредитированный полимодальный психотерапевт, психолог, преподаватель психологии. 
              Действительный член Общероссийской Профессиональной Психотерапевтической Лиги (ОППЛ), 
              член Санкт-Петербургской Организации Транзактного Анализа (СОТА), обучающий личный терапевт КОЛТ ОППЛ, 
              супервизор, преподаватель ОППЛ.
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  10+
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                лет <span className="fw-700">психологической практики</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Клиенты:</p>
            <p className="text-4 text-dark fw-600 mb-0">> 2000 клиентов</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Личная супервизия:</p>
            <p className="text-4 fw-600 mb-0">> 200 часов</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">Личная терапия:</p>
            <p className="text-4 text-dark fw-600 mb-0">> 200 часов</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <p className="text-muted fw-500 mb-0">Профессиональная подготовка:</p>
            <p className="text-4 text-dark fw-600 mb-0">> 10900 часов</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
